export const HEADER_TEST_IDS = <const>{
  menu: 'header.menu',
  newChat: 'header.new-chat',
  modeToggle: 'header.mode-toggle',
  minimize: 'header.minimize',
  more: 'header.more',
  close: 'header.close',
  menuPin: 'header.menu.pin',
  menuRemove: 'header.menu.remove',
};

export const ASK_DECISION_TEST_IDS = <const>{
  card: 'ask-decision.card',
  dropdownTrigger: 'ask-decision.dropdown-trigger',
  multiSelect: 'ask-decision.multi-select',
  skip: 'ask-decision.skip',
  confirm: 'ask-decision.confirm',
};
